import styled from 'styled-components';

import Icon from '../Icon';

export const Root = styled.div`
  color: ${({ theme }) => theme.colors.textSecondary};
  border-radius: 100%;
  padding: 6px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.surfaceSecondary};
    color: ${({ theme }) => theme.colors.textPrimary};
  }
`;
export const ThemeIcon = styled(Icon)``;
